module.exports = __webpack_public_path__ + "media/images/element/14-bf1b041e710c6f2b2f98021568d8ed46.svg";